export const features = {
  title: {
    features: 'Features',
    'features-updated': 'Features updated',
    'search-all-features': 'Search all features',
    'search-matches': '%{smart_count} match |||| %{smart_count} matches',
    'argos-intelligence': 'Argos Intelligence',
    'argos-intelligence-desc':
      "Argos Intelligence will contextualize all collected intel items with the customer's dedicated profile to provide targeted, real-time intelligence items. Using our Machine Learning algorithms and sophisticated Scoring Engine, intel items will be classified according to severity. Together with enriching the intel items using our comprehensive Cyber Knowledgebase, analysts can quickly sort through the important and most relevant intel items to get an accurate image of the Threat Landscape of the customer.",
    phishint: 'Phishing Detection',
    tem: 'Threat Exposure Management',
    temAccess: 'Threat Exposure Management Access',
    temMap: 'Threat Exposure Management Live Map',
    takedown: 'Takedown',
    'takedown-desc': 'Click-to-takedown capabilities for alerts',
    'takedown-notifications': 'Takedown Notifications',
    'takedown-notifications-desc': 'Email notifications for successful takedowns',
    'domain-squatting': 'Look-alike Domains Monitoring',
    'domain-squatting-desc':
      'Track and monitor look-alike newly registered domains for their activity inside the platform',
    'experimental-automatic-alerts': 'Experimental Automatic Alerts (Alpha)',
    'malicious-file-targeting-employees': 'Malicious File Targeting Employee',
    'internal-email-correspondence': 'Internal Email Correspondence',
    'customer-credentials-for-sale': 'Customer Credentials Offered for Sale',
    'employee-credentials-for-sale': 'Employee Credentials Offered for Sale',
    'customer-payment-cards-for-sale': 'Customer Payment Cards Offered for Sale (Alpha)',
    'credential-stuffing-tool-targeting-company': 'Credential Stuffing Tool Targeting Company',
    'fraudulent-refund-services-targeting-company': 'Fraudulent Refund Services Targeting Company (Alpha)',
    'fraudulent-refund-tutorial-targeting-company': 'Fraudulent Refund Tutorial Targeting Company (Alpha)',
    'automatic-phishing-alert': 'Phishing',
    'automatic-lookalike-domain-alert': 'Look-alike Domains',
    'automatic-hijackable-subdomain': 'Hijackable Subdomains',
    'automatic-payment-cards': 'Payment Cards',
    'company-source-code-exposed': 'Company Source Code Exposed',
    'company-confidential-file-exposed': 'Company Confidential File Exposed',
    'ransomware-attack-targeting-company': 'Ransomware Attack Targeting Company (Alpha)',
    'breached-data-potentially-related-to-company': 'Breached Data Potentially Related to Company',
    'phishing-kit-targeting-company': 'Phishing Kit Targeting Company (Alpha)',
    'data-scraping-tool-for-company-application': 'Data Scraping Tool for Company Application (Alpha)',
    'fraudulent-account-temp-phone': 'Fraudulent Account Registered Using Temporary Phone Number (Alpha)',
    'automatic-exposed-access-token': 'Exposed Access Token',
    'automatic-exposed-cloud-storage': 'Exposed Cloud Storage',
    'automatic-employee-machine-infected-by-malware': 'Employee Machine Infected',
    'automatic-exposed-web-interface': 'Exposed Web Interface',
    'automatic-email_security-missing_spf': 'Missing Company Domain SPF Records',
    'automatic-email_security-missing_dmarc': 'Missing Company Domain DMARC Records',
    'automatic-missing_caa': 'Missing Company Domain CAA Records',
    'automatic-company_mail_server_blocklisted': 'Company Mail Server Blocklisted',
    'automatic-mobile_app_impersonating_company': 'Mobile App Impersonating Company',
    'automatic-mobile_app_distributed_unofficially': 'Mobile App Distributed Unofficially',
    'automatic-vulnerable_technology_on_asset': 'Vulnerable Technology Detected On Exposed Company Asset',
    'automatic-vulnerable_technology_detected_on_manually_added_technology':
      'Vulnerable Manually Added Technology Detected',
    'automatic-exploitable_technology_on_asset': 'Exploitable Vulnerability found on a Company Asset',
    'automatic-exploit_found_on_company_asset': 'Exploit found on a Company Asset',
    'automatic-ssl_tls_certificate_expiry': 'SSL/TLS Certificate Expiry Notice',
    'automatic-tls_outdated_version_ssl_tls_supported': 'Outdated SSL/TLS Version Supported',
    'automatic-tls_latest_version_not_supported': 'TLS 1.3 Not Supported',
    'automatic-tls_no_forward_secrecy': "Cipher Suites Don't Support Forward Secrecy",
    'automatic-tls_server_has_known_vulnerability': 'Known SSL/TLS Vulnerability Detected',
    'automatic-tls_insecure_cipher_suites': 'Insecure SSL/TLS Cipher Suites Detected',
    'automatic-tls_weak_cipher_suites': 'Weak SSL/TLS Cipher Suites Detected',
    'automatic-tls_server_accepts_insecure_renegotiation': 'Insecure SSL/TLS Renegotiation Enabled',
    'automatic-web_app_security_missing_hsts_header_detected': 'Missing HSTS Header Detected',
    'automatic-web_app_security_misconfigured_hsts_header_detected': 'Misconfigured HSTS Header Detected',
    'automatic-web_app_security_missing_x_frame_options_header_detected': 'Missing X-Frame-Options Header Detected',
    'automatic-web_app_security_misconfigured_x_frame_options_header_detected':
      'Misconfigured X-Frame-Options Header Detected',
    'automatic-web_app_security_missing_x_content_type_options_header_detected':
      'Missing X-Content-Type-Options Header Detected',
    'automatic-web_app_security_misconfigured_x_content_type_options_header_detected':
      'Misconfigured X-Content-Type-Options Header Detected',
    'automatic-web_app_security_missing_content_security_policy_header_detected':
      'Missing Content-Security-Policy Header Detected',
    'automatic-web_app_security_missing_referrer_policy_header_detected': 'Missing Referrer-Policy Header Detected',
    'automatic-web_app_security_missing_x_permitted_cross_domain_policies_header_detected':
      'Missing X-Permitted-Cross-Domain-Policies Header Detected',
    'supply-chain-intelligence': 'Supply Chain Intelligence',
    'alerts.automatic.social_media_account_impersonating_company': 'Social Media Account Impersonating Company',
    'alerts.automatic.social_media_account_impersonating_company_executive':
      'Social Media Account Impersonating Company Executive',
    'social-media-malicious': 'Social Media Malicious Content Alert',
    'social-media-malicious-desc':
      'Receive ongoing, real-time alerts on malicious comments in your official social media pages. These are comments containing links that lead to phishing sites, downloading malware payloads or just to a page containing some sort of scam, targeting your users and customers.',
    'social-media-posts': 'Social Media Posts Monitoring',
    'social-media-posts-desc':
      'Avoid awkward posts on your social media pages with a link that doesn’t work. Get alerted immediately when a post you publish contains a link leading to no-where.',
    'websites-js-vulnerabilities': 'Websites JS Vulnerabilities Protection',
    'websites-js-vulnerabilities-desc':
      "Get real-time alerts on any JavaScript vulnerabilities found on your website. The feature will scan your website continuously, and alert you on code changes, code additions, vulnerabilities and malicious codes in your imported libraries as well as any 3rd party JavaScript-based tools and libraries you may utilize in your website. We're scanning all JavaScript libraries on an on-going manner, checking against the most updated vulnerabilities DBs and alerting you in real-time on any possible threat.",
    'social-media-defacement': 'Social Media Defacement Alert',
    'social-media-defacement-desc':
      'Get real-time alerts on any major change in your social media pages. Image, description, website address and any other major change to your official social pages will be immediately alerted on.',
    'automatic-alerts': 'Automatic Alerts',
    'customer-credentials': 'Customer Credentials',
    corporate_credentials_exposed: 'Employee Corporate Credentials Exposed',
    third_party_credentials_exposed: 'Employee 3rd Party Credentials Exposed',
    'exploitable-ports': 'Exploitable Ports',
    overview: 'Overview',
    'overview-desc': 'Platform overview for executives',
    'author-profile': 'Author Profile',
    'thread-view': 'Thread View',
    'author-quick-start': 'Author Quick Start',
    api: 'API',
    ioc: 'IOC',
    ioc_query: 'Query IOCs',
    feed: 'Feed',
    view_my_account: 'My Account',
    view_home: 'Home',
    collaboration_email: 'Email',
    collaboration_comment: 'Comments',
    api_translate_unlimited: 'Translation',
    feeds_credentials: 'Compromised Credentials Search',
    view_author_investigation: 'Author Investigation',
    view_thread_view: 'Thread View',
    view_intelligence_archive: 'Intel Data Lake',
    non_targeted_intelligence_news_access: 'News Ticker',
    forensics_investigate: 'Forensics',
    forensics_quick_investigation: 'Forensics Quick Investigation',
    takedown_submit: 'Takedown Requests',
    phishint_collection_squatting: 'Lookalike Domain',
    view_my_digital_footprint: 'ASM',
    my_digital_footprint_action_discovery_full: 'ASM Assets Discovery',
    my_digital_footprint_action_scan_full: 'ASM Issue Scanning',
    my_digital_footprint_demo: 'ASM Demo',
    api_query_ioc: 'API - IOC Query',
    api_download_ioc_daily_feed: 'API - IOC Daily Feed',
    alerts_automatic_employee_corporate_credentials: 'Automatic Alert - Company Employee Corporate Credentials Exposed',
    alerts_automatic_exploitable_port: 'Automatic Alert - Exploitable Ports',
    alerts_automatic_exposed_cloud_storage: 'Automatic Alert - Exposed Cloud Storage',
    alerts_automatic_exposed_web_interface: 'Automatic Alert - Exposed Web Interfaces',
    alerts_automatic_employee_third_party_credentials: 'Automatic Alert - Employee 3rd Party Credentials Exposed',
    alerts_automatic_hijackable_subdomains: 'Automatic Alert - Hijackable Subdomains',
    view_alerts: 'Alerts',
    alerts_notifications: 'Alerts Notifications',
    reports_notifications: 'Reports Notifications',
    collaboration_reports: 'Reports',
    view_executive_dashboard: 'Executive Dashboard',
    alerts_automatic_email_security_missing_spf: 'Automatic Alert - Missing Company Domain SPF Records',
    alerts_automatic_email_security_missing_dmarc: 'Automatic Alert - Missing Company Domain DMARC Records',
    alerts_automatic_missing_caa: 'Automatic Alert - Missing Company Domain CAA Records',
    alerts_automatic_company_mail_server_blocklisted: 'Automatic Alert - Company Mail Server Blocklisted',
    phishint_analysis_squatting: 'Phishing & Lookalike Domain Detection',
    intl_analyze: 'Threat Intelligence',
    leaked_credentials: 'Leaked Credentials',
    query_credentials: 'Query Leaked Credentials',
    investigation: 'Investigation Request',
    investigation_notifications: 'Investigation Request Notifications',
    rawIntel: 'Threat Intelligence',
    rawIntelDataCollection: 'Raw Intelligence Data Collection',
    iocView: 'IOC Details View',
    riAdvanced: 'Threat Intelligence Targeted Features',
    digitalRiskProtection: 'Digital Risk Protection',
    remediationAndInvestigation: 'Remediation and Investigation',
    threatHunting: 'Global Intelligence',
    asm: 'Attack Surface Monitoring',
    asmView: 'ASM View',
    asmMonitor: 'ASM Monitoring',
    alerts: 'Alerts Center Module',
    alertsView: 'Alert Center View',
    takedowns: 'Takedown Request',
    news: 'Cyber Security News',
    cve: 'CVE Intelligence',
    forensics: 'Forensics Canvas',
    reports: 'Cyber Threat Reports',
    phishing: 'Phishing Detection and Lookalike Domains',
    lookalike: 'Look-alike Domains Monitoring',
    twitter: 'Twitter',
    youtube: 'YouTube',
    github: 'Github',
    postman: 'Postman',
    googleDorks: 'Google Dorks',
    grayhatWarfare: 'Grayhat Warfare',
    ebay: 'Ebay',
    malwareLogs: 'Malware Log Shops',
    officialAppStores: 'Official App Stores',
    thirdPartyAppStores: '3rd-Party App Stores',
    intelDataLake: 'Intelligence Data Lake',
    issueScanning: 'Exposure Item Detection',
    assetDiscovery: 'Asset Discovery',
    fcUIAuthorQuickStart: 'Author Quick Start',
    reportsNotification: 'Reports Notifications',
    onGoingScan: 'Daily Exposure Scan',
    validation: 'Automatic Asset Validation and Scoping',
    licenseView: 'Show Assets Licensing and Utilization data in ASM',
    risk_assessment: 'Risk Assessment',
    scheduledDiscovery: 'Weekly Assets Discovery and Exposure Items Scan',
    takedownsNotifications: 'Takedown Request Notifications',
    credsPurchased: 'Purchase Leaked Credentials Offered for Sale',
    credsNotifications: 'Purchase Notifications',
    alertsNotifications: 'Alerts Notifications',
    generateCustomizedAlertsDataLake: 'DataLake Custom Threat Hunting Rules',
    generateCustomedAlertRawIntel: 'Raw Intelligence Custom Threat Hunting Rules',
    panoptes: 'ThreatScope AI Assistant (Beta)',
    email: 'Email',
    comments: 'Comments',
    advanced: 'Advanced',
    special_features: 'Special Features',
    socialMediaFakePages: 'Social Media Fake Pages',
    socialMediaCrawler: 'Crawler - Profile Collection From Social Media',
    socialMediaView: 'Social Media Fake Pages View ',
    basic: 'Basic',
    hide: 'Hide',
    delete: 'Delete',
    translation: 'Translation',
    home: 'Raw Intelligence Dashboard',
    account_settings: 'Account Settings',
    newLicenseModel: 'New License Model',
    general: 'General',
    compromised_creds: 'Compromised Credentials Search',
    assetMgmt: 'Management',
    assetCreate: 'Asset Management',
    multi_tenant: 'Multi Tenant',
    msspCreditConsumption: 'MSSP Credit Consumption',
    msspTenantCreation: 'Tenant Creation',
    supplyChainIntelligence: 'Supply Chain',
    supplyChainIntelligenceModule: 'Supply Chain Discovery Monitoring and Alerting',
    supplyChainRansomwareAttackTargetingThirdPartyVendor: 'Ransomware Attack Targeting Third Party Vendor',
    socialMediaAccountImpersonatingCompany: 'Social Media Account Impersonating Company',
    socialMediaAccountImpersonatingCompanyExecutive: 'Social Media Account Impersonating Company Executive',
    supplyChainThirdPartyVendorBreached: 'Third Party Vendor Breached',
    aiSummary: 'AI-assisted Summary',
    aiAlertSummary: 'Alert AI Summary',
    aiCapabilities: 'AI Capabilities',
    autoCloseAlert: 'Close an alert automatically when Exposure closed',
    technologyDiscovery: 'Technology Discovery',
    manualTechnologyAddition: 'Manual Technology Addition',
    activeVulnerabilityScan: 'Active Exposure Validation',
    scheduledActiveVulnerabilityScan: 'Scheduled weekly Active Exposure Validation',
    automaticAevAlertsValidation: 'Automatic AEV Alerts Closure',
    quantumIntegration: 'Quantum™ Network Security Integration',
    caasmIntegration: 'CAASM Integration',
    caasmAccess: 'CAASM Access',
    securityPostureScoreCalculation: 'Security Posture Score Calculation',
    msspSummaryView: 'Environment Summary',
    author_profile: 'Author Profile',
    thread_view: 'Thread View',
    // ioc: 'IOC',
    // ioc_query: 'Query IOCs',
    ioc_feed: 'IOC Feed',
    // leaked_credentials: 'Leaked Credentials',
    api_leaked_credentials: 'Leaked Credential APIs',
    api_leaked_credentials_broad_query: 'Broad Query Leaked Credentials',
    self_service: 'Self Service',
    in_review: 'In Review',
    alert_clone: 'Clone Alert',
    unified_alerts_view: 'Unified Alerts View',
    asset_grouping_view: 'Asset Group View',
    leaked_credentials_screen: 'Leaked Credentials Screen'
  },
  summary: {
    tem: 'Threat Exposure Management',
    temAccess: 'Access Threat Exposure Management features',
    temMap: 'Access Threat Exposure Management Live Attack Map Page',
    home: 'Enable the Raw Intelligence Dashboard that provides useful telemetrics.',
    securityPostureScoreCalculation: 'Enable the Security Posture calculation and widgets',
    alertsView: 'Enable Alert Center for effective management and mitigation of alerts',
    generateCustomedAlertRawIntel:
      'Enable the creation of custom Rolls that generate alerts on top of Raw Intelligence.',
    assetMgmt: 'Argos Management modules.',
    supplyChainIntelligenceModule:
      'Enable Supply Chain vendors discovery, monitoring and alerts on elevated supply chain risks.',
    threatHunting: 'Argos Global Intelligence modules.',
    remediationAndInvestigation: 'Argos Takedown, Purchased Leaked Credentials and Investigation modules.',
    socialMediaView: 'Enable the Social Media Fake Pages View.',
    socialMediaCrawler: 'Enable the collection of Raw Intel from Social media.',
    digitalRiskProtection: 'Argos Digital Risk Protection Modules.',
    rawIntelDataCollection: 'Enable the Raw Intelligence Data Collection view.',
    iocView: 'Enable display of Indicators of Compromise (IOCs) within Threat Actor and Malware card.',
    technologyDiscovery:
      'Enable the discovery of technologies hosted on monitored external facing assets.Flag also enables Certificate discovery and view.',
    activeVulnerabilityScan: 'Enable active exposure validation, which also includes agentic AI-driven scanning.',
    scheduledActiveVulnerabilityScan: 'Enable scheduled active exposure validation.',
    asmView: 'Enable the ASM View.',
    self_service: 'Manage your alert settings and view capabilities within your managed environment.',
    in_review: 'Activate In Review to create alerts and view alerts currently under review.',
    alert_clone: 'Clone Alert between different environments.',
    unified_alerts_view: 'Enable a unified view of all subtenants alerts.',
    investigation: 'Enable the Investigation Request view and the Investigation initiation from alerts.',
    investigation_notifications: 'Enable an email notification for Investigations.',
    social_media_posts:
      "Avoid awkward posts on your social media pages with a link that doesn't work. Get alerted immediately when a post you publish contains a link leading to no-where.",
    rawIntel: 'Argos Raw Intelligence data collection modules.',
    riAdvanced:
      'Activate Argos Threat Intelligence for targeted collected sources (Social Media, Code Repositories, Search Engines, Marketplaces and\\or Mobile App Stores).',
    asm: 'Continuous discovery of all externally facing digital assets,  vulnerabilities and misconfigurations scanning.',
    alerts:
      'Activate Argos Alert Center to enable automatic detection and effective alert management and mitigation through Argos Alert Center.',
    takedowns: 'Enable Takedown Request view, Takedown Request initiation from alerts and manual takedown.',
    credsPurchased: 'Enable Purchased Request view and the Purchase Request initiation from alerts.',
    credsNotifications: 'Enable an email notification for Purchased credential requests.',
    news: 'Activate Argos News Ticker to keep track of the most up-to-date cyber-security developments, News Ticker aggregates trending news from various OSINT sources, such as ZDNet, Dark Reading, and others.',
    cve: 'Vulnerability Intelligence view provides a list of vulnerabilities, their Cyberint risk scores, and threat intelligence enrichment.',
    forensics:
      'Conduct deep investigations based on multiple services integrated into a unified investigation platform to support various types of connections.',
    reports:
      'Activate Argos Reports to enable customers to download targeted and non-targeted reports and receive reports notifications.',
    phishing: 'Enable Phishing and Lookalike Domains engines and the Lookalike domains view.',
    scheduledDiscovery: 'Enable a weekly discovery and Exposure scanning.',
    generateCustomizedAlertsDataLake: 'Create custom rules that generate alerts on top of the data Intelligence.',
    panoptes: 'AI Virtual Threat Hunting Assistant.',
    onGoingScan: 'Enable a daily vulnerabilities and misconfigurations scan.',
    twitter: '',
    youtube: '',
    github: '',
    postman: '',
    googleDorks: '',
    grayhatWarfare: '',
    ebay: '',
    malwareLogs: '',
    officialAppStores: '',
    thirdPartyAppStores: '',
    intelDataLake: 'Enable Argos Data Lake for advanced threat hunting and monitoring.',
    issueScanning: 'Enable ASM vulnerabilities and misconfigurations detection on monitored assets.',
    assetDiscovery: 'Enable ASM externally facing digital assets discovery.',
    fcUIAuthorQuickStart: '',
    automaticAevAlertsValidation: 'Enable automatic closure of AEV alerts.',
    quantumIntegration: 'Enable ASM integration with Quantum™ Network Security.',
    caasmIntegration: 'Enable ASM integration with CAASM.',
    caasmAccess: 'Enable CAASM Access',
    reportsNotification: 'Enable cyber threat reports notifications.',
    takedownsNotifications: 'Enable an email notification for Tenant Admins.',
    alertsNotifications: 'Enables customized notifications per user.',
    validation: 'Enable Argos automatic validation and scoping engine to ensure maximum coverage and protection.',
    licenseView: 'Enable Asset Licensing and Utilization widgets.',
    manualTechnologyAddition: 'Enable manual addition of technologies into the technologies inventory.',
    newLicenseModel: 'Activate visibility of the new 2024 tenants and license model features.',
    supplyChainIntelligence: 'Monitor, alert, and manage risks within your supply chain.',
    applicableForPremiumVendorsOnly:
      'Enable automatic alert. Please note: These alerts will be triggered on Premium vendors only.',
    aiSummary: 'Enable AI assistance on Intel Items.',
    aiAlertSummary: 'Enable AI assistance on alerts.',
    assetCreate: 'Enable Assets Management including the creations, removal and configuration of assets.',
    msspTenantCreation: 'Provides MSSPs with the ability to create tenants on their own.',
    autoCloseAlert:
      'Ensure that alerts are closed automatically when the Exposure is not longer detected. Does not apply to the “Company Subdomain Vulnerable to Hijacking” alert type due to security reasons.',
    cveIntelAndTechDiscoveryShouldBeOnForAutomation:
      'CVE Intelligence and Technology Discovery Feature Flags must be turned on for this Automation to operate.',
    msspSummaryView: 'Enable a summary of all sub tenants risk and status.',
    socialMediaFakePages:
      'Activate Social Media Fake pages to enable continuous detection of fake profiles from support social media websites.',
    api_leaked_credentials: 'Check credentials specifically for domains within your tenant’s scope',
    api_leaked_credentials_broad_query:
      'Search for leaked credentials globally across all users, beyond your tenant’s domain',
    leaked_credentials_screen: 'Enable Leaked Credentials Management Screen under Threat Intelligence section',
    asset_grouping_view: 'Enable Group Attribution for Assets'
  },
  categories: {
    mobileApp: 'Mobile App Stores',
    marketPlaces: 'Marketplaces',
    codeRepos: 'Code Repositories',
    socialMedia: 'Social Media',
    searchEngine: 'Search Engines',
    supplyChainAutomaticAlerts: 'Supply Chain Automatic Alerts'
  },
  autoAlerts: {
    asmAutoAlerts: 'ASM Automatic Alerts',
    tiAutomaticAlerts: 'Threat Intelligence Automatic Alerts',
    drp: 'Digital Risk Protection Automatic Alerts',
    supplyChainAlerts: 'SupplyChain Automatic Alerts',
    noAutoAlerts: "No Automatic Alerts to select due to the features you've selected in the Features screen"
  },
  aggregated_features: {
    'view.alerts': 'Alert Center',
    'view.executive_dashboard': 'Executive Dashboard',
    'alerts.notifications': 'Alert Notifications',
    'my_digital_footprint.action.scan.full': 'Full ASM Issue Scanning',
    'my_digital_footprint.action.score': 'ASM Score',
    'my_digital_footprint.action.exploitability_validation': 'Exploitability Validation',
    'my_digital_footprint.exploitability_validation.scheduled.full': 'Scheduled Exploitability Validation',
    'view.author_investigation': 'Author Investigation View',
    'view.thread_view': 'Thread View',
    'collaboration.email': 'Share Indicator via Email',
    'collaboration.comment': 'Write a Comment on an Indicator',
    'api.translate.unlimited': 'Unlimited Data Translation (no character limit)',
    'api.translate.limited': 'Limited Data Translation (character limit applies)',
    'phishint.collection.squatting': 'Lookalike Domains Collection',
    'view.intelligence_archive': 'Data Lake',
    'feeds.indicators': 'Indicators Feed',
    'forensics.investigate': 'Forensics Investigation',
    'forensics.quick_investigation': 'Quick Forensics Investigation'
  },
  asset_features: {
    'intl.search.search_engine.scribd': {
      label: 'SCRIBD',
      tooltip:
        'Scribd is a digital document-sharing platform monitored to detect matches involving Document Identifier asset types. It helps uncover leaked or sensitive content—such as internal reports or proprietary data—that may have been publicly exposed.'
    },
    'intl.search.search_engine.google': {
      label: 'Google Dorks',
      tooltip: ''
    },
    'intl.search.search_engine.grayhatwarfare': {
      label: 'Open Buckets Search',
      tooltip: 'Online repositories that allow searching for open cloud buckets and detect potentially sensitive files'
    },
    'intl.search.marketplace.malware_logs': {
      label: 'Malware Log Shops',
      tooltip:
        'Automated online stores that sells credentials, fingerprints, web platform vulnerabilities, cookies, and various sensitive data that assist cybercriminal hackers in gaining initial access into the targeted victim network.'
    },
    'intl.search.app_store.official': {
      label: 'Official Apps Stores',
      tooltip:
        'Digital stores such as Google Play and Apple’s app store, may contain fake apps that are impersonating the companies brands / Products and are used for malicious, fraudulent or brand abusing purposes'
    },
    'intl.search.app_store.third_party': {
      label: '3rd Party App Stores',
      tooltip:
        "Argos monitors several mobile app stores, that are not the official distribution channel of the companies apps, and therefore may be using the company's app as a lure to attract traffic and potentially distribute malware, or other illegitimate causes"
    },
    'intl.search.social_media.twitter': {
      label: 'Twitter',
      tooltip: ''
    },
    'intl.search.social_media.youtube': {
      label: 'Youtube',
      tooltip:
        'An online video sharing and social media platform, that may contain brand abusing / sensitive / infringing content related to the company.'
    },
    'intl.search.code_repos.github': {
      label: 'GitHub',
      tooltip:
        "A code hosting platform that may contain exposed sensitive code created by the company or third party's, or malicious / brand abusing code."
    },
    'intl.search.code_repos.postman': {
      label: 'Postman',
      tooltip:
        "Postman is an API Platform for developers to design, and their APIs, may contain exposed sensitive code created by the company or third party's."
    },
    'phishint.analysis.content': {
      label: 'Monitor for Phishing',
      shortLabel: 'Phishing',
      tooltip: 'For detection of Phishing websites that mention the asset value in their URL, HTML, and Logo'
    },
    'phishint.analysis.squatting': {
      label: 'Monitor for Lookalike Domains',
      shortLabel: 'Lookalike Domains',
      tooltip:
        'For detection of new domains that are similar to the domain or its twists. Lookalike domains will a high similarity rate will also be also be monitored for Phishing'
    },
    'intl.analyze': {
      label: 'Global Intelligence Collection',
      tooltip:
        'Threat Intelligence sources that Argos collects ongoingly in a global manner, regardless of a match on a specific asset.'
    },
    social_media_pages: {
      label: 'Monitor for Social Media',
      shortLabel: 'Social Media',
      tooltip: "For detection of asset's impersonating users and pages in Social Media Fake Pages module"
    },
    'intl.search.social_media.pages.facebook': {
      label: 'Facebook'
    },
    'intl.search.social_media.pages.instagram': {
      label: 'Instagram'
    },
    'intl.search.social_media.pages.tiktok': {
      label: 'Tiktok'
    },
    'intl.search.social_media.pages.linkedin': {
      label: 'LinkedIn'
    },
    'intl.search.social_media.pages.twitter': {
      label: 'Twitter'
    },
    asm: {
      label: 'Attack Surface Monitoring',
      shortLabel: 'ASM',
      disabledNote:
        'ASM is always enabled. Disabling the asset in the ASM screen can only be done after completely deleting it from this table.',
      tooltip:
        'Monitor your asset for security issues and vulnerabilities and use it for the discovery of new assets and technologies.'
    },
    ti: {
      label: 'Threat Intelligence Collection',
      shortLabel: 'TI',
      disabledNote: 'TI is always enabled.',
      tooltip:
        'Gain insights of threats from the ever-growing list of sources such as open, deep & dark web, chat apps, Paste Sites, code repositories and many more.\nThese sources are collected by Argos ongoingly in a global manner, regardless of a match on a specific asset.'
    },
    drp: {
      label: 'Digital Risk Protection',
      shortLabel: 'DRP',
      disabledNote: 'DRP is always enabled.',
      tooltip:
        'Intercept emerging phishing threats before an attack is executed.\nMonitor active lookalike domains, suspicious websites and Social Media fake accounts impersonating your brand.'
    },
    inactive: {
      label: 'No Coverage',
      shortLabel: 'None'
    }
  },
  disclaimers: {
    aev: "Before activating the Active Exposure Vulnerability (AEV) feature, ensure you have obtained written approval from the prospect. The AEV feature performs active scanning on the prospect's digital assets and has the potential to generate a high volume of alerts. If the SOC team and other stakeholders are not given prior notification, they may mistakenly believe a cyber-attack is underway.",
    quantumIntegration:
      'The Infinity tenant ID is missing. Please add your Infinity tenant ID under the Infinity Tenants section to make the Quantum™ Integration work properly. Also, ensure that Infinity ERM Integration is enabled within the Quantum™ SmartConsole system.',
    partial: 'This feature is missing these values',
    msspAev:
      "Before activating the Active Exposure Vulnerability (AEV) feature, ensure you have obtained written approval from the prospect. The AEV feature performs active scanning on the prospect's digital assets and has the potential to generate a high volume of alerts. If the SOC team and other stakeholders are not given prior notification, they may mistakenly believe a cyber-attack is underway. \n\n**Note: For each monitored domain or manually added monitored IP, two additional credits will be consumed per ASM monitored asset.**"
  }
};
